module.exports = __webpack_public_path__ + "img/diskominfo_kota.a373d8cb.png";